import * as PIXI from 'pixi.js'
import * as Rx from 'rxjs'
import R from "../../config/R"
import * as Events from '../../Events'
import Image from "../../objects/Image";
import * as _ from "lodash";
import SoundManager from "../../SoundManager";
import TWEEN from "@tweenjs/tween.js"
const TOTAL_CORRECT_QUESTIONS = R.settings.common.totalCorrectQuestions

export class Timer extends PIXI.Container {
  constructor(x,y, resources){
    super()
    this.x = x
    this.y = y

    const bg = new Image(0,0, resources[R.images.timerBox.name].texture)
    const textStyle = {
      ...new PIXI.TextStyle(R.textStyles.timer(60)),
      fill: '#ffffff',
    }

    const textContainer = new PIXI.Text(`0/${TOTAL_CORRECT_QUESTIONS}`, textStyle)

    textContainer.anchor.x = 0.5
    textContainer.anchor.y = 0.5

    this.addChild(bg)
    this.addChild(textContainer)

    this.textContainer = textContainer

    this.score = 0
  }

  addScore(){
    this.score += 1
    this.textContainer.text = `${this.score}/${TOTAL_CORRECT_QUESTIONS}`
  }


  flashing(){
    setTimeout(() => {
      SoundManager.instance.playEffect(R.sounds.d, () => {
        SoundManager.instance.playEffect(R.sounds.d, () => {
          SoundManager.instance.playEffect(R.sounds.d)
        })
      })
    }, 1000)
    return new TWEEN.Tween(this)
      .delay(4500)
  }
}



// WEBPACK FOOTER //
// ./src/game/characters/common/Timer.js